import {Outlet , Navigate} from 'react-router-dom'; 
import useAuthStatus from '../hooks/useAuthStatus';
import Loading from "./Spinner"

export default function PrivateRoute() {

const {loggedIn, checkingStatus}  = useAuthStatus();
if(checkingStatus )
{
    return <Loading/>;
}
    return loggedIn ? <Outlet/>   : <Navigate  to="/signin"/>
}